import { combineReducers, configureStore } from '@reduxjs/toolkit';

import iamReducer from './store/iam/reducer';
import salesReducer from './store/sales/reducer';
import trackersReducer from './store/trackers/reducer';
import trackedWebsitesReducer from './store/tracked_websites/reducer';
import notificationsReducer from './store/notifications/reducer';

import { trackedWebsitesApi, locationsAndLanguagesApi } from './trackedWebsites/service';
import { backlinksApi } from './backlinks/service';
import { topKeywordsApi } from './topKeywords/service';
import { keywordResearchApi } from './keywordResearch/service';
import { trackedKeywordsApi } from './trackedKeywords/service';
import { siteSpeedApi } from './siteSpeed/service';
import { siteOutageApi } from './outage/service';
import { deepAnalysisApi } from './deepAnalysis/service';
import { llmToolsApi } from './llmAnalysis/service';
import { competitorDomainsApi } from './competitorDomains/service';
import { analysisApi } from './analysis/service';
import { whiteLabelApi } from './whiteLabel/service';
import { salesApi } from './sales/service';


const rootReducer = () =>
    combineReducers({
        iam: iamReducer,
        sales: salesReducer,
        tracked_websites: trackedWebsitesReducer,
        notifications: notificationsReducer,
        trackers: trackersReducer,
        [siteOutageApi.reducerPath]: siteOutageApi.reducer,
        [siteSpeedApi.reducerPath]: siteSpeedApi.reducer,
        [trackedKeywordsApi.reducerPath]: trackedKeywordsApi.reducer,
        [keywordResearchApi.reducerPath]: keywordResearchApi.reducer,
        [topKeywordsApi.reducerPath]: topKeywordsApi.reducer,
        [trackedWebsitesApi.reducerPath]: trackedWebsitesApi.reducer,
        [locationsAndLanguagesApi.reducerPath]: locationsAndLanguagesApi.reducer,
        [backlinksApi.reducerPath]: backlinksApi.reducer,
        [deepAnalysisApi.reducerPath]: deepAnalysisApi.reducer,
        [llmToolsApi.reducerPath]: llmToolsApi.reducer,
        [competitorDomainsApi.reducerPath]: competitorDomainsApi.reducer,
        [analysisApi.reducerPath]: analysisApi.reducer,
        [whiteLabelApi.reducerPath]: whiteLabelApi.reducer,
        [salesApi.reducerPath]: salesApi.reducer,
    });

export const store = configureStore({
    reducer: rootReducer(),
    middleware: (getDefaultMiddleware) => {
        return getDefaultMiddleware()
            .concat(backlinksApi.middleware)
            .concat(trackedWebsitesApi.middleware)
            .concat(locationsAndLanguagesApi.middleware)
            .concat(topKeywordsApi.middleware)
            .concat(keywordResearchApi.middleware)
            .concat(trackedKeywordsApi.middleware)
            .concat(siteSpeedApi.middleware)
            .concat(siteOutageApi.middleware)
            .concat(deepAnalysisApi.middleware)
            .concat(llmToolsApi.middleware)
            .concat(competitorDomainsApi.middleware)
            .concat(analysisApi.middleware)
            .concat(whiteLabelApi.middleware)
            .concat(salesApi.middleware);
    },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
export const dispatch = store.dispatch;
